import { useEffect } from "react";
import Lenis from "lenis";
import { useSite } from "@/context/SiteContext";
import { trackPageView } from "@/lib/tracking/tracker";
import { TrustBar, Nav } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problem } from "@/components/landing/Problem";
import { Benefits } from "@/components/landing/Benefits";
import { Ingredients, HowToUse } from "@/components/landing/Formula";
import { Offer } from "@/components/landing/Offer";
import { Expert } from "@/components/landing/Expert";
import { Consultation, Testimonials, Certificates } from "@/components/landing/Trust";
import { Faq, FinalCta, Footer, StickyBar } from "@/components/landing/Closing";
import { LeadModal, OrderModal } from "@/components/landing/Modals";
import { Seo } from "@/components/landing/Seo";

const useSmoothScroll = (paused) => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let id = requestAnimationFrame(function raf(t) { lenis.raf(t); id = requestAnimationFrame(raf); });
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => {
    if (!window.__lenis) return;
    if (paused) window.__lenis.stop(); else window.__lenis.start();
  }, [paused]);
};

export default function Landing() {
  const { modal } = useSite();
  useSmoothScroll(!!modal.type);
  useEffect(() => { trackPageView(); }, []);
  return (
    <div data-testid="landing-page" className="min-h-screen bg-bone">
      <Seo />
      <TrustBar />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Problem />
        <Benefits />
        <Ingredients />
        <HowToUse />
        <Offer />
        <Expert />
        <Consultation />
        <Testimonials />
        <Certificates />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyBar />
      <LeadModal />
      <OrderModal />
    </div>
  );
}
